import React from 'react';
import PropTypes from 'prop-types';
import useModal from '../../hooks/useModal';
import ContactFormModal from './ContactFormModal';

const ContactFormButton = ({
	btnAttrs = { className: '', style: {} },
	iconCls,
	trackingHandler,
	staffMember,
	isWithinModal = false
}) => {
	const { show, handleOpen, handleClose } = useModal(trackingHandler);

	return (
		<>
			<button type="button" onClick={handleOpen} {...btnAttrs}>
				<i className={iconCls} /> {isWithinModal && 'Contact'}
			</button>

			{show && (
				<ContactFormModal
					show={show}
					handleClose={handleClose}
					staffMember={staffMember}
				/>
			)}
		</>
	);
};

ContactFormButton.propTypes = {
	btnAttrs: PropTypes.shape({
		className: PropTypes.string,
		style: PropTypes.objectOf(PropTypes.string)
	}).isRequired,
	iconCls: PropTypes.string.isRequired,
	trackingHandler: PropTypes.func.isRequired,
	staffMember: PropTypes.shape({
		name: PropTypes.string,
		email: PropTypes.string
	}).isRequired,
	isWithinModal: PropTypes.bool
};

export default ContactFormButton;
